import { onScrollTo } from './../utility/onScrollTo'


// get offset of chosen element relative to another (most likely its parent)
function getOffset(parent, element, center = false) {
	const parentRect = parent.getBoundingClientRect()
	const elementRect = element.getBoundingClientRect()
	return {
		left: elementRect.left - parentRect.left + (center ? parentRect.width / 2 : 0),
		top: elementRect.top - parentRect.top + (center ? parentRect.height / 2 : 0),
		height: parentRect.height,
		width: parentRect.width
	}
}

function videoLines(pElem) {

	const cElem = document.querySelector('.m-background-video__content__inner')
	const lineX = pElem.querySelector('.m-background-video__line--horizontal')
	const lineY = pElem.querySelector('.m-background-video__line--vertical')

	function updateLines() {

		const contentOffset = getOffset(pElem, cElem)
		const lineSpace = 40 // how far to space out lines from Chosen Element

		lineX.style.left = `0px`
		lineX.style.top = `${contentOffset.top - lineSpace}px`

		lineY.style.left = `${contentOffset.left - lineSpace}px`
		lineY.style.top = `${contentOffset.top - (lineSpace * 2)}px`
	}

	function init() {
		updateLines()
		lineX.classList.add("draw")
		lineY.classList.add("draw")
		window.addEventListener('resize', updateLines);
	}

	onScrollTo(pElem, init, { offset: -500 })

}

export default function init() {
	const modules = [...document.querySelectorAll('.m-background-video')]
	modules.map(videoLines)
}